<div class="refund-order-dialog-wrapper">
  <div class="refund-order-dialog-title d-flex align-items-center">
    <h2 class="p-0 me-2" mat-dialog-title>{{ 'orders.cancelActionInfo.refundSelection' | translate }}</h2>
    @if(!isSingleSelection()) {
    <mat-icon
      [ngbTooltip]="'orders.info.aRefundWillBeCreatedByFolder' | translate"
      [openDelay]="700"
      tooltipClass="refund-order-header-ttp"
      [placement]="'auto'"
      [closeDelay]="500"
    >
      info_outline
    </mat-icon>
    }
  </div>

  <mat-dialog-content>
    <div class="refund-order-content">
      @if(showCustomerSection()) {
      <div class="refund-order-customer-selection">
        <app-payment-customer-section
          [selectionTitle]="'orders.customerToBeRefunded'"
          [selectedCustomer]="selectedCustomer()"
          [isEditMode]="isCustomerStepInProgress()"
          (customerChange)="onCustomerChange($event)"
          (edit)="editCustomer()"
        ></app-payment-customer-section>
      </div>
      }
      <app-payment-method-section
        [selectionTitle]="'orders.refundMethod'"
        [isEditMode]="isSingleSelection() ? isPaymentStepInProgress() : false"
        [form]="isSingleSelection() ? form : null"
        [paymentModes$]="paymentModes$"
        [totalAmount$]="isSingleSelection() ? totalAmount$ : null"
        [cancelPaymentModes]="isSingleSelection() ? cancelPaymentModes : []"
        [availablePaymentModes]="availablePaymentModes"
        [selectedPaymentMode]="selectedPaymentMode"
        [displayMode]="paymentMethodDisplayMode()"
        [paymentTypes]="paymentTypes"
        (edit)="editPaymentMode()"
        (paymentModeChange)="paymentModeChange($event)"
        (amountToReturnChange)="amountToReturn = $event"
      ></app-payment-method-section>
      <div class="refund-order-refunds-list" [class.border-top-single]="isSingleSelection()">
        @if(showRefundsListTitle()){
        <h5 class="mt-3">{{ 'orders.cancelActionInfo.listOfRefunds' | translate }}</h5>
        }

        <app-summary-list
          [items]="allSummaryItems"
          [title]="isSingleSelection() ? '' : ('orders.cancelActionInfo.listOfRefunds' | translate)"
          [summaryLabelCallback]="summaryLabel"
          [maxDisplayedItems]="maxDisplayedLines"
        >
        </app-summary-list>
      </div>

      <div class="refund-order-footer" id="refund-order-footer">
        <app-validated-form-row [isRemoveHidden]="true" [isEditHidden]="true">
          <ng-template #labelTemp>
            <div class="refund-footer-label">
              <span>{{ 'shared.payment.totalAmount' | translate }}:</span>
              <span class="label-bold">
                {{ totalAmount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
              </span>
            </div>
          </ng-template>
        </app-validated-form-row>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions [align]="'end'">
    <div class="mb-3">
      <button mat-button (click)="onCancel()" class="tick-btn tick-btn-secondary">
        {{ 'shared.actions.cancel' | translate }}
      </button>
      <button
        mat-button
        class="tick-btn tick-btn-primary ms-1"
        (click)="onConfirm()"
        [disabled]="
          (isSingleSelection() &&
            ((isPaymentStepInProgress() && !form?.valid) ||
              !selectedCustomer() ||
              cancelPaymentModes.length === 0)) ||
          (!isSingleSelection() && !selectedPaymentMode)
        "
      >
        <span>{{ 'shared.actions.refund' | translate }}</span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
